<button mat-button class="ca-button ca-button-xs mb-2" (click)="drawer.open()">
    <ca-icon icon="settings" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.SET_DEFAULTS' | translate }}</span>
</button>

<ca-drawer #drawer [bodyBordered]="true">
    <h2 drawer-header class="ca-headline-2 ca-bold m-0">{{ headerText() | translate }}</h2>
    <div drawer-body class="flex flex-col">Question Flow goes here</div>
    <button drawer-footer mat-stroked-button class="ca-button ca-button-m" (click)="drawer.close()">
        <span>{{ 'CA.BUTTON.CANCEL' | translate }}</span>
    </button>
    <button drawer-footer mat-flat-button class="ca-button ca-button-m" (click)="drawer.close()">
        <span>{{ 'CA.BUTTON.CONFIRM' | translate }}</span>
    </button>
</ca-drawer>
